export default __webpack_public_path__ + "static/media/kitchen-pack.e2c567e7.png";